import { Container, Row, Col, Image, Button, Modal } from "react-bootstrap";
import "./meetUs.css";
import hhSalon from "../../media/images/ruPlace.jpg";
import emppa from "../../media/images/Emilia.jpeg";
import Helmet from "react-helmet";
import homepagePic from "../../media/images/homepagePic.png";
import julia from "../../media/images/Julia_profile_pic.jpeg";
import hanna from "../../media/images/hanna.jpg";
import aysin from "../../media/images/newWorker.jpg";
import { useEffect, useState } from "react";
import ga from "../../googleAnalytics";
import { COMPANY_NAME, WEBSITE } from "../../globals";
import { useNavigate } from "react-router-dom";

export const MeetUs = ({ language }) => {
  useEffect(() => {
    ga.trackPageView();
  }, []);

  const [modalVisible, setModalVisible] = useState(false);
  const [index, setIndex] = useState(0);

  const closeModal = () => setModalVisible(false);
  const openModal = (i) => {
    setIndex(i);
    setModalVisible(true);
  };
  return (
    <div>
      <Helmet>
        <title>{COMPANY_NAME} | Meet us</title>
        <meta
          name="description"
          property="og:description"
          content="Haluatko tietää meistä lisää? Tapaa meidät täällä"
        />
        <meta property="og:title" content="Meet Us" />
        <meta property="og:url" content={`${WEBSITE}/meetUs`} />
        <meta property="og:image" content={homepagePic} />
        <meta
          name="keywords"
          content="hairdresser, parturi, Make up, salon, Helsinki, Mikonkatu, kampaamo, website, meet us, about, parturikampaamo, kampaaja, meistä, om oss, frisör, Helmi Helsinki "
        />
      </Helmet>
      <Container className="container-page meetUs-cont">
        <Row>
          <Col>
            <h1 style={{ textAlign: "center", marginBottom: "1vh" }}>
              {language === "fin" && "Meistä"}
              {language === "eng" && "About us"}
              {language === "swe" && "Om oss"}
            </h1>
          </Col>
        </Row>
        <Row>
          <Col md={5} id="meetus-pic-col">
            <Image alt="salon pic" src={hhSalon} className="meetUs-pic"></Image>
          </Col>
          <Col md={7} style={{ fontSize: "1.2rem", liheHeight: "1.5rem" }}>
            <Row className="meetUs-description-flex">
              <Col>
                {language === "fin" && (
                  <div>
                    Ota hetken irtiotto arjesta ja tule Forma Helsinkiin. Meiltä
                    löydät laajan valikoiman parturi-, kampaamo-, kampaus- sekä
                    meikkipalveluita. Toteutamme tyyliisi sopivan kokonaisuuden.
                    Palvelemme ammattitaidolla ja asiakkaan toiveita huomioon
                    ottaen. Kouluttaudumme myös jatkuvasti pysyäksemme mukana
                    uusimmissa trendeissä. Suurin osa hiustuotteistamme ovat
                    vegaanisia ja mahdollisimman luonnonmukaisia. Myynnissä
                    meiltä löytyy Davines, Björk sekä Eleven Australian
                    hiustuotteita.{" "}
                  </div>
                )}
                {language === "eng" && (
                  <div>
                    Take time for yourself and come to Forma Helsinki. We offer
                    a wide range of barber-, hairdressing-, updo- and makeup
                    services. We will create a look that fits your style. We
                    offer professional services and always take the customers
                    wishes into consideration. We are also educating ourselves
                    to stay on board with the newest trends. Most of our
                    hairproducts are vegan and as organic as possible. We sell
                    Davines, Björk and Eleven Australia hair products.
                  </div>
                )}
                {language === "swe" && (
                  <div>
                    Ta tid för dig själv och kom till Forma Helsinki. Hos oss
                    hittar du ett brett urval av barberar-, frisör-,
                    håruppsättnings- och sminktjänster. Vi gör en helhet som
                    passar just dig. Vi håller oss även uppdaterade inom det
                    nyaste inom hårtrender. De flesta av våra produkter är
                    veganska och så organiska som möjligt. Vi säljer Davines,
                    Björk och Eleven Australia hårprodukter.
                  </div>
                )}
              </Col>
              <Col md={12} style={{ fontSize: "1.2rem", liheHeight: "1.5rem" }}>
                <br />
                {language === "fin" && (
                  <div>
                    Avasimme ovemme vuonna 2019, mutta olemme kaikki olleet
                    alalla jo pidemmän aikaa. Aiemmin olimme useita vuosia
                    Yliopistonkadulla, jonka jälkeen olimme Vuorikadulla
                    muutaman vuoden. Sitten päätimme perustaa oman paikan; Forma
                    Helsinki. Olemme viihtyisä salonki, jossa ammattitaitoiset
                    ammattilaiset palvelevat sinua yksilöllisesti. Forma
                    Helsinki sijaitsee rauhallisella sisäpihalla Helsingin
                    ydinkeskustassa, Mikonkatu 13. Tervetuloa!
                  </div>
                )}
                {language === "eng" && (
                  <div>
                    We opened our doors in 2019, but we have been a long time in
                    the hairdressing industry. Earlier we worked several years
                    on Yliopistonkatu, then a few years on Vuorikatu. Then
                    finally we decided to open our own place Forma Helsinki. We
                    are a cozy salon, with experienced professionals that will
                    treat you individually. Forma Helsinki is located at a
                    courtyard in the centre of Helsinki, Mikonkatu 13. Welcome!{" "}
                  </div>
                )}
                {language === "swe" && (
                  <div>
                    Vi öppnade våra dörrar år 2019, men vi har varit inom
                    branschen en längre tid. Tidigare var vi ett flertal år på
                    Universitetsgatan, några år på Bergsgatan och sedan öppnade
                    vi äntligen vårt eget ställe; Forma Helsinki. Vi är en
                    trivsam salong där professionella stylister tar väl hand om
                    dig. Forma Helsinki befinner sig på en trivsam innergård i
                    mitten av Helsingfors centrum, Mikaelsgatan 13. Välkommen!{" "}
                  </div>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="meetUs-row"></Row>
      </Container>

      <Container fluid>
        <Row className="meetUs-row meetUs-worker-row">
          <div className="meetUs-worker-row-overlay"></div>
          <h1 className="meetUs-titles">
            {language === "fin" && "Sinua Palvelevat"}
            {language === "eng" && "At your service"}
            {language === "swe" && "Vi betjänar dig"}
          </h1>
          <WorkerItem index={0} openModal={openModal} language={language} />
          <WorkerItem index={1} openModal={openModal} language={language} />
          <WorkerItem index={2} openModal={openModal} language={language} />
          <WorkerItem index={3} openModal={openModal} language={language} />
        </Row>
      </Container>
      <MeetUsMoreInfoModal
        show={modalVisible}
        onHide={closeModal}
        index={index}
        language={language}
      ></MeetUsMoreInfoModal>
    </div>
  );
};

const ReadMoreButton = ({ id, openModal, language }) => {
  return (
    <Button
      variant="outline-secondary"
      className="read-more-employee-info-btn"
      onClick={() => openModal(id)}
    >
      {language === "fin" && "Lue lisää"}
      {language === "swe" && "Läs mera"}
      {language === "eng" && "Read more"}
    </Button>
  );
};

const WorkerItem = ({ language, openModal, index }) => {
  const data = ModalData[index];
  return (
    <Col
      xs={9}
      lg={{ offset: index === 0 ? 0 : 1, span: 2 }}
      className="meetUs-worker-col"
    >
      <Row className="flex-center-column">
        <Col className="image-col">
          <Image
            alt={data.name}
            src={data.source}
            className="workers-pic"
          ></Image>
        </Col>
        <Col className="worker-name">{data.name}</Col>
        <Col xs={4}>
          <div
            style={{ borderBottom: "0.5px solid black", height: "2px" }}
          ></div>
        </Col>
        <Col className="worker-xp"> {data.speciality[language]}</Col>
        <Col className="d-flex justify-content-center">
          <ReadMoreButton
            id={index}
            openModal={openModal}
            language={language}
          />
        </Col>
      </Row>
    </Col>
  );
};

const MeetUsMoreInfoModal = ({ show, onHide, index, language }) => {
  const data = ModalData[index];
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      animation
      dialogClassName="scrollable-modal custom-modal"
    >
      <Modal.Header closeButton className="absolute-header"></Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={{ span: 6 }} md={4}>
            <div className="meet-us-modal-pic-div">
              <Image
                className="meet-us-modal-pic"
                src={data.source}
                fluid
              ></Image>
            </div>
          </Col>
          <Col xs={12} md={8}>
            <Row>
              <Col xs={12}>
                <h3>
                  <b>{data.name}</b>
                </h3>
              </Col>
              <Col xs={12}>
                <h5 style={{ marginBottom: "2.6rem" }}>
                  <i>{data.speciality[language]}</i>
                </h5>
              </Col>
              <Col xs={12}>
                {data.description[language].split("\\n").map((line, index) => (
                  <p
                    className="meet-us-modal-description"
                    key={index}
                    style={{ marginBottom: "2rem" }}
                  >
                    {line}
                  </p>
                ))}
              </Col>
              {data.url.length > 1 && (
                <BookTime
                  language={language}
                  url={data.url}
                  description={data.bookDescription[language]}
                />
              )}
            </Row>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

const BookTime = ({ language, url, description }) => {
  const navigate = useNavigate();
  const handleNavigate = (url) => {
    ga.trackGAEvent("worker_individual_modal", "book_buttons", "book_now");
    url[0] === "/" ? navigate(url) : redirectToHannaTimma(url);
  };

  const redirectToHannaTimma = (url) => {
    console.log(url);
    window.location.href = `${url}`;
  };
  return (
    <Col className="flex-center-column">
      <div className="worker-xp">
        <p>{description}</p>
      </div>
      <Button variant="outline-secondary" onClick={() => handleNavigate(url)}>
        {language === "fin" && "Varaa tästä"}
        {language === "eng" && "Book here"}
        {language === "swe" && "Boka här"}
      </Button>
    </Col>
  );
};

const ModalData = [
  {
    name: "Emilia",
    speciality: {
      fin: "Hiukset | Meikki",
      eng: "Hair | Makeup",
      swe: "Hår | Makeup",
    },
    description: {
      fin: "Olen työskennellyt hiusten ja meikkien parissa noin 15 vuoden ajan. \nPidän erityisesti raidoituksista, kampauksista, meikeistä ja pidennystöistä, mutta teen mielelläni kaikkia hiuksiin liittyviä töitä.\\nOlen tarkka työssäni, ja minulle on tärkeää kuunnella asiakasta. Yhdessä löydämme juuri sinun tyyliisi sopivan lopputuloksen.",
      swe: "Jag har arbetat med hår och makeup i 15 år. \nJag tycker särskilt mycket om att göra slingor, uppsättningar, makeup och hårförlängningar, men jag gör gärna alla typer av hårarbeten. \\nJag är noggrann i mitt arbete, och det är viktigt för mig att lyssna på kunden. Tillsammans skapar vi ett resultat som passar just din stil.",
      eng: "I have been working with hair and makeup for about 15 years. \nI especially enjoy creating highlights, updos, makeup looks, and hair extensions, but I’m happy to do all kinds of hair work.\\nI’m precise in what I do, and it’s important to me to listen to my client. Together we create a result that perfectly suits your style.",
    },
    source: emppa,
    url: "/booking",
    bookDescription: {
      fin: "Varaa aikasi tästä",
      swe: "Boka din tid här",
      eng: "Book your time here",
    },
  },
  {
    name: "Julia",
    speciality: {
      fin: "Hiukset",
      eng: "Hair",
      swe: "Hår",
    },
    description: {
      fin: "Moikka! Olen toiminut parturi-kampaajana vuodesta -97. \nSuorituksiini kuuluu muun muassa lukuisia Sassoon-koulutuksia ja vahvuuksiani ovat leikkaus, värjääminen, vaalentaminen sekä raidoitus. \nSaan helposti inspiraatioita uusista trendeistä.",
      swe: "Hej! Jag har arbetat som frisör sedan år 1997. \nTill mina meriter hör bland annat flera Sassoon-utbildningar, och mina styrkor är klippning, färgning, blekning samt slingor. \nJag får lätt inspiration från nya trender.",
      eng: "Hi! I’ve been working as a hairdresser since 1997. My achievements include several Sassoon training courses, and my strengths are cutting, coloring, lightening, and highlights. I easily find inspiration from new trends.",
    },
    source: julia,
    url: "/booking",
    bookDescription: {
      fin: "Varaa aikasi tästä",
      swe: "Boka din tid här",
      eng: "Book your time here",
    },
  },
  {
    name: "Hanna",
    speciality: {
      fin: "Hiukset | Meikki",
      eng: "Hair | Makeup",
      swe: "Hår | Makeup",
    },
    description: {
      fin: "Hei, olen parturikampaaja.\nPidän värien ja raidoitusten sekä kampausten tekemisestä. Minulta luontuu parturityöt, mutta myös mm. permanentin ja meikkien teko. Pyrin palvelemaan kaikki asiakkaat huolellisesti heidän toiveita kuunnellen.\\nTässä työssä ilahduttaa mukavat kohtaamiset ja hyvät keskustelut ihmisten kanssa. Olet lämpimästi tervetullut tuoliini.",
      swe: "Hej, jag är frisör.\nJag tycker om att arbeta med färgningar, slingor och uppsättningar.\nJag gör gärna även herrklippningar, men också till exempel permanent och smink.\nJag strävar efter att betjäna alla kunder noggrant och lyssna på deras önskemål.\\nI det här arbetet gläds jag åt trevliga möten och goda samtal med människor. Du är hjärtligt välkommen till min stol!",
      eng: "Hi, I’m a hairdresser.\nI enjoy working with colors, highlights, and hairstyles.\nI’m also skilled in men’s cuts, as well as perms and makeup. I always aim to serve every client carefully, listening to their wishes.\\nWhat I love most about this job are the pleasant encounters and good conversations with people. You are warmly welcome to my chair!",
    },
    source: hanna,
    url: "https://varaa.timma.fi/tmihannaheikkila",
    bookDescription: {
      fin: "Tästä voit varata ajan Hannalle",
      swe: "Here you can book your time with Hanna",
      eng: "Här kan du boka din tid hos Hanna",
    },
  },
  {
    name: "Aysin",
    speciality: {
      fin: "Hiukset",
      eng: "Hair",
      swe: "Hår",
    },
    description: {
      fin: "Olen iloinen rento parturi-kampaaja, jolla on vuosia takana reilu 20 vuotta. Työni sydän on asiakkaiden tyytyväisyys — halu, että jokainen lähtee tuolistani hymy huulilla ja hiukset juuri oman tyylinsä mukaisesti. \\nErityisosaamistani  ovat  värjäykset, raidat, permanentit sekä erilaiset kampaukset ,niin arkeen kuin juhlaankin. Rakastan luoda uusia lookeja ja tuoda esiin asiakkaan persoonallisuuden hiusten kautta. \\nLämpimästi tervetuloa ! Nähdään Formassa\\nVaraa aikasi Aysinille numerosta:\n050 5126063",
      swe: "Jag är en glad och trevlig frisör med över 20 års erfarenhet i branschen. Hjärtat i mitt arbete är kundnöjdhet - jag vill att varje kund lämnar min stol med ett leende på läpparna och en frisyr som passar just deras stil. \\nMin specialitet är färgningar, slingor, permanent och olika typer av uppsättningar både till vardag och fest.  Jag älskar att skapa nya looks och lyfta fram kundens personlighet genom håret.\\nVarmt välkommen! Vi ses på Forma.\\nBoka din tid hos Aysin från numret:\n050 5126063",
      eng: "I’m a cheerful and easygoing hairdresser with over 20 years of experience in the industry. The heart of my work is customer satisfaction - my goal is that every client leaves my chair with a smile and a hairstyle that perfectly suits their own style. \\nMy specialties include coloring, highlights, perms, and various updos - for both everyday wear and special occasions. I love creating new looks and bringing out each client’s personality through their hair. \\nA warm welcome! See you at Forma.\\nBook your time with Aysin from the number: \n050 5126063",
    },
    source: aysin,
    url: "",
    bookDescription: {
      fin: "",
      swe: "",
      eng: "",
    },
  },
];
